import React from "react";
import { Chip } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { formatDateTime } from "utils/date";
import { pluralize } from "utils/string";
import {
  SUBSCRIPTION_PAUSE_HISTORY_STATUS,
  SUBSCRIPTION_PAUSE_HISTORY_STATUS_CHIP,
} from "static/constants";

const useStyles = makeStyles(() => ({
  card: {
    padding: "16px",
    border: "1px solid #E0E0E0",
    borderRadius: "4px",
  },
  statusChip: {
    height: "20px",
    marginBottom: "8px",
    fontSize: "12px",
    backgroundColor: "#FFFFFF",
  },
  details: {
    display: "grid",
    gridTemplateColumns: "144px 1fr",
    rowGap: "8px",
    alignItems: "center",
  },
  label: {
    color: "#9E9E9E",
    fontSize: "14px",
    lineHeight: "20px",
  },
  value: {
    color: "#333333",
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 500,
  },
}));

const getDaysPausedText = ({ status, days_paused, ended_on }) => {
  const daysPaused = pluralize(days_paused, "day");

  if (status === SUBSCRIPTION_PAUSE_HISTORY_STATUS.resumedEarly) {
    return `${daysPaused} (resumed early on ${formatDateTime(ended_on)})`;
  }

  if (status === SUBSCRIPTION_PAUSE_HISTORY_STATUS.removed) {
    return `${daysPaused} (removed on ${formatDateTime(ended_on)})`;
  }

  if (status === SUBSCRIPTION_PAUSE_HISTORY_STATUS.deactivated) {
    return `${daysPaused} (patient deactivated on ${formatDateTime(ended_on)})`;
  }

  return daysPaused;
};

const PAUSE_HISTORY_DETAILS = [
  { label: "Reason", getValue: (pause) => pause.disabled_reason },
  {
    label: "Pause Start Date",
    getValue: (pause) => formatDateTime(pause.pause_start_date),
  },
  {
    label: "Pause End Date",
    getValue: (pause) => formatDateTime(pause.pause_end_date),
  },
  { label: "Days Paused", getValue: getDaysPausedText },
];

const PauseHistoryCard = ({ pause }) => {
  const classes = useStyles();
  const statusChip = SUBSCRIPTION_PAUSE_HISTORY_STATUS_CHIP[pause.status];

  return (
    <div className={classes.card}>
      {statusChip && (
        <Chip
          size="small"
          variant="outlined"
          label={statusChip.label}
          className={classes.statusChip}
          style={{
            color: statusChip.color,
            borderColor: statusChip.color,
          }}
        />
      )}

      <div className={classes.details}>
        {PAUSE_HISTORY_DETAILS.map(({ label, getValue }) => (
          <React.Fragment key={label}>
            <span className={classes.label}>{label}</span>
            <span className={classes.value}>{getValue(pause) || "-"}</span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default PauseHistoryCard;
